import { Component, Input } from '@angular/core';

@Component({
  selector: 'read-only-field',
  templateUrl: './read-only-field.component.html',
  standalone: false,
})
export class ReadOnlyFieldComponent {
  @Input() horizontalAlign = 'center';
  @Input() val: number | string | null = null;

  public get horizontalAlignCssClass(): string {
    return `justify-${this.horizontalAlign}`;
  }
}
